// extracted by mini-css-extract-plugin
export default {"card":"styles_card__HsRTV","announcement":"styles_announcement__45N-t","subject":"styles_subject__V5Rtv","description":"styles_description__LD+jD"};